import {
  connectFunctionsEmulator,
  type Functions,
  getFunctions,
} from "firebase/functions"
import { getFirebaseApp } from "./getFirebaseApp"

// `connectFunctionsEmulator` mutates the SDK instance and throws if called
// twice with the same host/port, so we track whether we've already wired it
// for this module's lifetime. `getFunctions(app)` is idempotent per the SDK,
// so no separate cache for the Functions instance itself.
let emulatorConnected = false

// Browser-side Firebase Functions client. Used only by the SSO flow, which
// invokes Callable Functions before a session cookie exists — every other
// callable goes through the server-side `callableClient`.
export const getFirebaseFunctions = (): Functions => {
  const functions = getFunctions(getFirebaseApp())

  if (!emulatorConnected && process.env.NEXT_PUBLIC_FUNCTIONS_EMULATOR_HOST) {
    const [host, port] =
      process.env.NEXT_PUBLIC_FUNCTIONS_EMULATOR_HOST.split(":")
    connectFunctionsEmulator(functions, host, Number(port))
    emulatorConnected = true
  }

  return functions
}
